import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling, {
  type FieldErrorsMapper
} from '@/hooks/useMutationWithErrorsHandling'

import type { CoverTeacherFormSchema } from '../constants/cover-payload'

const fieldErrorsMapper: FieldErrorsMapper<CoverTeacherFormSchema> = {
  teacher_cover: 'teacher',
  co_teacher_1_cover: 'coTeacher',
  non_field_error: 'root'
}

const useSetCover = (
  lessonId: string,
  options?: {
    onSuccess: (validData: CoverTeacherFormSchema) => void
    onError: () => void
  }
) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: CoverTeacherFormSchema) =>
      httpService.panel.panelLessonsCoverPartialUpdate(lessonId, {
        teacher_cover: data.teacher?.value || null,
        co_teacher_1_cover: data.coTeacher?.value || null,
        comment: data.comment
      }),
    onSuccess: (_, variables) => options?.onSuccess?.(variables),
    onError: () => options?.onError?.(),
    fieldErrorsMapper
  })

export default useSetCover
